
enum ArticleStockLocationType {
    WAREHOUSE = "WAREHOUSE",
    DELIVERY_PERSON = "DELIVERY_PERSON"
}
export default ArticleStockLocationType